/**
 * The status words, one set for every screen, so the same item never reads two
 * ways (backlog 08a7f075). Only what a person reads lives here: ids stay as the
 * server sends them and each screen keeps its own colours. A filter chip may
 * say the plural ("Drafts").
 */
export const TO_APPROVE = 'To approve';

/** An article, by the Website list's buckets. */
export const ARTICLE_STATUS = {
  review: TO_APPROVE,
  draft: 'Draft',
  scheduled: 'Scheduled',
  live: 'Live',
} as const;

export type ArticleBucket = keyof typeof ARTICLE_STATUS;

/** A post, by its reachStatus. `missed`: its time passed; `skipped`: a person said no. */
export const POST_STATUS = {
  waiting: TO_APPROVE,
  draft: 'Draft',
  scheduled: 'Scheduled',
  publishing: 'Posting',
  posted: 'Posted',
  missed: 'Didn’t post',
  skipped: 'Skipped',
  deleting: 'Deleting',
  deleted: 'Deleted',
} as const;

/**
 * Which bucket an article is in: the server's rule for the list (topicsPage).
 * Waiting on a yes comes first, whatever else is true of it, so To approve here
 * always matches Today's count. Then by its publish status, where anything
 * neither scheduled nor a draft is live.
 */
export function articleBucket(
  awaitingApproval: boolean | null | undefined,
  status: string | null | undefined
): ArticleBucket {
  if (awaitingApproval) return 'review';
  const s = status || 'draft';
  if (s === 'scheduled') return 'scheduled';
  if (s === 'draft') return 'draft';
  return 'live';
}

/** A live article with nothing to read says so in the list (backlog b4e3ef5a). */
export function emptyLive(topic: {
  title?: string | null;
  publishStatus?: string | null;
  bodyEmpty?: boolean | null;
}): string | null {
  if (topic.publishStatus !== 'published') return null;
  const noTitle = !String(topic.title || '').trim();
  if (noTitle && topic.bodyEmpty) return 'Live with no title or text';
  if (noTitle) return 'Live with no title';
  return topic.bodyEmpty ? 'Live with no text' : null;
}
